<template>
    <nav class="border-b border-gray-200 sticky top-0 z-50" :style="{ backgroundColor }">
        <div class="px-5 lg:px-[120px] py-[15px] flex justify-between items-center">
            <!--Logo-->
            <router-link to="/" class="flex items-center gap-2">
                <img class="w-[169px] h-[50px] object-contain hidden lg:block" :src="$asset(logoLight, 'public')" alt="HKCM Logo" title="HKCM Logo" />
                <img class="w-[50px] h-auto block lg:hidden" :src="$asset(logoSmallLight, 'public')" alt="HKCM Logo" title="HKCM Logo" />
            </router-link>
            <router-link
                v-if="showCta"
                :to="ctaLink"
                class="px-5 py-[10px] rounded-full font-semibold transition text-sm lg:text-[16px] text-white hover:opacity-90"
                :style="{ background: `linear-gradient(to right, ${buttonGradientFrom}, ${buttonGradientTo})` }"
            >
                {{ ctaText }}
            </router-link>
        </div>
    </nav>

    <!-- Bauchbinde / Ticker -->
    <div v-if="showTicker" class="ticker-wrapper" :style="{ backgroundColor: tickerBackgroundColor }">
        <div class="ticker">
            <div class="ticker-content">
                <span v-for="i in 5" :key="i" class="ticker-item" :class="tickerTextColor" v-html="tickerText"> </span>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    backgroundColor: {
        type: String,
        default: '#FFFFFF'
    },
    logoLight: {
        type: String,
        default: '/hkcm/images/logo-on-light-background.svg'
    },
    logoSmallLight: {
        type: String,
        default: '/hkcm/images/logo-small-on-light-background.svg'
    },
    ctaText: {
        type: String,
        default: 'Entdecken'
    },
    ctaLink: {
        type: String,
        default: '/'
    },
    showCta: {
        type: Boolean,
        default: true
    },
    buttonGradientFrom: {
        type: String,
        default: '#1E40AF'
    },
    buttonGradientTo: {
        type: String,
        default: '#1E3A8A'
    },
    showTicker: {
        type: Boolean,
        default: false
    },
    tickerText: {
        type: String,
        default: '🚀 Jetzt neu: Das HKCM Altcoin-Paket'
    },
    tickerBackgroundColor: {
        type: String,
        default: '#006CFF'
    },
    tickerTextColor: {
        type: String,
        default: 'text-white'
    }
});
</script>

<style scoped>
.ticker-wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
    padding: 0.75rem 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.ticker {
    display: flex;
    width: 100%;
}

.ticker-content {
    display: flex;
    animation: scroll 60s linear infinite;
    white-space: nowrap;
}

.ticker-item {
    display: inline-block;
    padding: 0 3rem;
    font-weight: 400;
    font-size: 1.125rem;
}

@keyframes scroll {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

/* Pause animation on hover */
.ticker-wrapper:hover .ticker-content {
    animation-play-state: paused;
}
</style>
